import React, { useCallback, useState } from 'react';

import { Button } from '~/components/button';
import { FormattedMessage, useIntl } from '~/contexts/intl';
import { CANCELLATION_TERMS_URL, openUrl, renderLink } from '~/utils/open-url';

import { AppointmentActionDescription, AppointmentActionTitle } from './appointment-actions';

export type AppointmentModifyProps = {
    modifiable: boolean;
    onModifyCalendarEvent: () => Promise<void>;
};

export function AppointmentModify(props: AppointmentModifyProps) {
    const { modifiable, onModifyCalendarEvent } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const { formatMessage } = useIntl();

    const handleModifyCalendarEvent = useCallback(async () => {
        setLoading(true);
        try {
            await onModifyCalendarEvent();
        } catch (error) {
            // Re-enable only on failure — on success the modal is closing and the button
            // must stay disabled so it can't re-fire during the hide animation.
            setLoading(false);
            throw error;
        }
    }, [onModifyCalendarEvent]);

    const handleLink = useCallback(async () => {
        // TODO: For now, we'll just open the cancellation terms URL for both cases
        // This can be updated later if different URLs are needed for different cases
        await openUrl(CANCELLATION_TERMS_URL);
    }, []);

    return (
        <>
            <AppointmentActionTitle>
                <FormattedMessage id="appointment.modify.title" values={{ modifiable }} />
            </AppointmentActionTitle>
            <AppointmentActionDescription>
                <FormattedMessage
                    id="appointment.modify.description"
                    values={{
                        link: renderLink(handleLink),
                        modifiable
                    }}
                />
            </AppointmentActionDescription>
            {modifiable ? (
                <Button
                    alignCenter
                    fillContainer
                    loading={loading}
                    type="secondary"
                    shape="rounded"
                    label={formatMessage('appointment.modify')}
                    onPress={handleModifyCalendarEvent}
                />
            ) : null}
        </>
    );
}
